import React, { useMemo, useState } from 'react';
import { Button, Card, Form, Input, message, Space, Typography } from 'antd';
import apiClient from '../../utils/apiService';

const { Title, Text } = Typography;

const CACHE_ALLOWED_USERS = new Set(['jerrytong', 'juchao', 'wanghe']);

function UserCenter() {
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();
  const [savingPwd, setSavingPwd] = useState(false);
  const [reloadingCache, setReloadingCache] = useState(false);

  const userInfo = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem('userInfo') || '{}');
    } catch (e) {
      return {};
    }
  }, []);

  const username = String(userInfo?.username || '').trim().toLowerCase();
  const canReloadCache = CACHE_ALLOWED_USERS.has(username);

  const handleChangePassword = async () => {
    try {
      const values = await form.validateFields();
      setSavingPwd(true);
      const res = await apiClient.post('/prime/auth/change-password', {
        currentPassword: values.currentPassword,
        newPassword: values.newPassword,
        confirmPassword: values.confirmPassword,
      });
      if (res?.data?.code === 200) {
        messageApi.success('Password Update Success');
        form.resetFields();
      } else {
        messageApi.error(res?.data?.message || 'Password update failed');
      }
    } catch (error) {
      if (error?.errorFields) return;
      messageApi.error(error?.response?.data?.message || error?.message || 'Password update failed');
    } finally {
      setSavingPwd(false);
    }
  };

  const handleReloadCache = async () => {
    try {
      setReloadingCache(true);
      const res = await apiClient.post('/shipping-order/detail-cache/reload');
      if (res?.data?.code === 200) {
        messageApi.success(res?.data?.message || '预加载任务已提交，后台执行中');
      } else {
        messageApi.error(res?.data?.message || '任务提交失败');
      }
    } catch (error) {
      messageApi.error(error?.response?.data?.message || error?.message || '任务提交失败');
    } finally {
      setReloadingCache(false);
    }
  };

  return (
    <div style={{ padding: 16 }}>
      {contextHolder}
      <div style={{ maxWidth: 720 }}>
        <Title level={4} style={{ marginTop: 0, marginBottom: 12 }}>User Center</Title>

        <Space direction="vertical" size={12} style={{ width: '100%' }}>
          <Card>
            <Title level={5} style={{ marginTop: 0 }}>Change Password</Title>
            <Form form={form} layout="vertical">
              <Form.Item
                label="Current Password"
                name="currentPassword"
                rules={[{ required: true, message: 'Please enter current password' }]}
              >
                <Input.Password placeholder="Please Enter Current Password" />
              </Form.Item>

              <Form.Item
                label="New Password"
                name="newPassword"
                rules={[{ required: true, message: 'Please enter new password' }]}
              >
                <Input.Password placeholder="Please Enter New Password" />
              </Form.Item>

              <Form.Item
                label="Confirm Password"
                name="confirmPassword"
                dependencies={['newPassword']}
                rules={[
                  { required: true, message: 'Please confirm new password' },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue('newPassword') === value) return Promise.resolve();
                      return Promise.reject(new Error('Passwords do not match'));
                    },
                  }),
                ]}
              >
                <Input.Password placeholder="Please Confirm New Password" />
              </Form.Item>

              <Button type="primary" onClick={handleChangePassword} loading={savingPwd}>
                Update Password
              </Button>
            </Form>
          </Card>

          {canReloadCache && (
            <Card>
              <Title level={5} style={{ marginTop: 0 }}>Order Detail Cache Reload</Title>
              <Text type="secondary">
                Trigger the asynchronous `/reload` task. Execution results will be sent to the Feishu group.
              </Text>
              <div style={{ marginTop: 12 }}>
                <Button type="primary" onClick={handleReloadCache} loading={reloadingCache}>
                  Trigger Reload Task
                </Button>
              </div>
            </Card>
          )}
        </Space>
      </div>
    </div>
  );
}

export default UserCenter;


